import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollToHero = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      const heroElement = document.getElementById('hero');
      if (heroElement) {
        heroElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      navigate('/');
      window.scrollTo(0, 0);
    }
  };

  const handleLinkClick = (to: string) => (e: React.MouseEvent) => {
    if (location.pathname === to) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#101010] text-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <Link
            to="/"
            onClick={handleScrollToHero}
            className="flex items-center gap-2 text-xl sm:text-2xl font-bold tracking-tight cursor-pointer"
          >
            <span className="text-white">MARKET</span>
            <span className="text-orange-500">MATE</span>
          </Link>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center w-full sm:w-auto">
            <label htmlFor="newsletter" className="sr-only">
              Subscribe to our Newsletter
            </label>
            <input
              id="newsletter"
              type="email"
              placeholder="Subscribe to our Newsletter"
              className="w-full sm:w-auto sm:min-w-[240px] rounded-full border border-gray-700 bg-[#161616] px-4 py-3 text-sm text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <button className="w-full sm:w-auto rounded-full bg-orange-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-orange-600">
              Subscribe
            </button>
          </div>
        </div>

        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div>
            <h4 className="text-orange-500 text-sm font-semibold uppercase tracking-[0.2em] mb-4">
              Be a part of us
            </h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <Link to="/" onClick={handleScrollToHero} className="hover:text-white transition-colors">
                  Join as a Customer
                </Link>
              </li>
              <li>
                <Link to="/" onClick={handleScrollToHero} className="hover:text-white transition-colors">
                  Be a Vendor
                </Link>
              </li>
              <li>
                <Link to="/" onClick={handleScrollToHero} className="hover:text-white transition-colors">
                  Become a Rider
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-orange-500 text-sm font-semibold uppercase tracking-[0.2em] mb-4">
              Links
            </h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <Link to="/about" onClick={handleLinkClick('/about')} className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" onClick={handleLinkClick('/faq')} className="hover:text-white transition-colors">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={handleLinkClick('/contact')} className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-orange-500 text-sm font-semibold uppercase tracking-[0.2em] mb-4">
              Privacy & Legal
            </h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li>
                <Link to="/terms" onClick={handleLinkClick('/terms')} className="hover:text-white transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy#privacy" onClick={handleLinkClick('/privacy#privacy')} className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy#acceptable-use" onClick={handleLinkClick('/privacy#acceptable-use')} className="hover:text-white transition-colors">
                  Acceptable Use Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy#refund-policy" onClick={handleLinkClick('/privacy#refund-policy')} className="hover:text-white transition-colors">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" onClick={handleLinkClick('/cookies')} className="hover:text-white transition-colors">
                  Cookies Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} MarketMate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
